import { ApolloLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

import { createAuthorizationHeaderValue } from './auth';

/** Creates the Auth link for Apollo. */
export function createAuthLink(): ApolloLink {
  return setContext(async (_, { headers }) => {
    const authorization = await createAuthorizationHeaderValue();
    return {
      headers: {
        ...headers,
        authorization,
      },
    };
  });
}
